import React, { createContext, useContext } from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../../Context/ZooPassAnswersContext";
import {StepTitleContent} from "../PanelContents/StepTitleContent";
import {ImageAnswerComponent} from "../PanelContents/ImageAnswer";
import ZooPassLocalStateUtility from "../../Utilities/ZooPassLocalStateUtility";
import ZooPassFetch from '../../Utilities/ZooPassFetch';
import { RenewalLoadingSegment, RenewalLoginSegment } from '../PanelContents/RenewalSupportingSegments';

export const Step2Panel : React.FC = () => {

    let {
        imageAnswers,
        textTitles,
        loading
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading,
        updateContext
    } = useZooPassAppAnswersContext();

    const handleValueClick = (value : null | 0 | 1) => {
        if(answersData != null){
            if(value === 0){
                //Advance
                answersData.step2RenewalPassId = null;
                answersData.step2Value = 0;
                answersData.previousStep = answersData.step;
                answersData.step = 3;
                ZooPassLocalStateUtility.SetLocalState(answersData);
                updateContext({type: "setAnswers", value: answersData});
            }
            if(value === 1){
                answersData.step2Value = 1;
                answersData.previousStep = answersData.step;
                if(answersData.step1Value == 0){
                    //Renew member
                    answersData.step = 2.01
                }else{
                    //Renew guest
                    answersData.step = 2.02;
                }
                ZooPassLocalStateUtility.SetLocalState(answersData);
                updateContext({type: "setAnswers", value: answersData});
            }
        }
        
    }
    
    const handleRadioKeyPress = (event : any, value : null | 0 | 1) => {
        if(!event.altKey && !event.metaKey && !event.shiftKey && event.key === 'Enter') {
            handleValueClick(value);
        }
    };
    
    return !answersLoading && !loading && 
        textTitles !== null &&
        answersData !== null && answersData.step == 2 && (
        <div className="container d-block">
            <StepTitleContent textTitle={textTitles.get("ZooPass:PageContent:02")}/>
            <div className="row g-4 mx-auto row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 justify-content-center w-auto">
                <ImageAnswerComponent imageAnswerData={imageAnswers.get("ZooPass:PageAnswer:02:New")} nameValue="step2"
                                    onKeyboardPress={(event) => handleRadioKeyPress(event, 0)}
                                    onClick={() => handleValueClick(0)} key="new" imageAltValue={null}/>
                <ImageAnswerComponent imageAnswerData={imageAnswers.get("ZooPass:PageAnswer:02:Renew")} nameValue="step2"
                                    onKeyboardPress={(event) => handleRadioKeyPress(event, 1)}
                                    onClick={() => handleValueClick(1)} key="renewal" imageAltValue={null}/>
            </div>
        </div>
        );
};

